import RiskName from "../riskName/riskName";
import { RisksId } from "../../../../helpers/risk";
import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import InsuranceSum from "../insuranceSum/insuranceSum";
import ToggleButtonGroupCustom from "../../../sharedComponents/toggleButtonGroup/toggleButtonGroup";
import { yesNo } from "../../../../helpers/yesNo";
import { displayAdditionalRiskForm } from "../../../../helpers/risksNetwork";
import { runInAction } from "mobx";

interface NonResidentialBuildingProps {
  calculateStore?: CalculateStore;
}

export function NonResidentialBuilding(props: NonResidentialBuildingProps) {
  const calculateStore = props.calculateStore!;
  const nonResidentialBuilding = calculateStore.additionalInsurances.nonResidentialBuilding;
  const flammableStructure = nonResidentialBuilding.flammableStructure;
  const displayForm = displayAdditionalRiskForm(nonResidentialBuilding);

  function getValue(value: boolean | undefined) {
    switch (value) {
      case true:
        return yesNo.yes;
      case false:
        return yesNo.no;
      default:
        return undefined;
    }
  }

  return (
    <div className="section non-residential-building">
      <RiskName
        checkboxOnChange={(event) => {
          calculateStore.setAdditionalInsuranceFieldChecked(RisksId.nonResidentialBuilding, event.target.checked);
        }}
        riskId={RisksId.nonResidentialBuilding}
        displayIcon={true}
      />

      {displayForm && (
        <div className="risk-value">
          <ToggleButtonGroupCustom
            question="Konstrukcja budynku lub pokrycie dachu łatwopalne"
            value={getValue(flammableStructure)}
            options={[{
              value: yesNo.yes,
              label: "TAK"
            }, {
              value: yesNo.no,
              label: "NIE"
            }]}
            onChange={(newValue) => {
              calculateStore.setNonResidentialBuildingFlammable(newValue === yesNo.yes);
              runInAction(() => {
                // TODO: create setter and remove 'runInAction'
                nonResidentialBuilding.errorMessage = "";
              });
            }}
            errorMessage={nonResidentialBuilding.errorMessage}
          />
          <InsuranceSum riskId={RisksId.nonResidentialBuilding} />
        </div>
      )}
    </div>
  );
}

export default inject("calculateStore")(observer(NonResidentialBuilding));
